module.exports = __webpack_public_path__ + "static/media/ticker_icon_cloud.1159bf2d.svg";